<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="d7e90">
<h1 class="chapno">
</h1><h2 class="chapttl" id="d7e91">Praise for The Complete Guide to Reverse Mortgages</h2>
<p class="tx1" id="d7e93">“If you have time to read only one book about reverse mortgages this is it.”</p>
<p class="tx1" id="d7e95">— <b>Peggy Gardner, J.D., C.P.A.,</b> President,</p>
<p class="tx1" id="d7e100">Estate Planning Council of Colorado Springs</p>
<p class="tx1" id="d7e102">“I predict <i>The Complete Guide to Reverse Mortgages</i> will become the most widely used third-party resource tool for potential borrowers, their families, and the professionals who advise them.”</p>
<p class="tx1" id="d7e107">— <b>Norman F. Peterson,</b> President,</p>
<p class="tx1" id="d7e112">Kirkpatrick Bank</p>
<p class="tx1" id="d7e114">“Every financial and retirement planning professional should read this book. This book unravels a complex and very important topic in a clear and entertaining style.”</p>
<p class="tx1" id="d7e116">— <b>Raj Joshi,</b></p>
<p class="tx1" id="d7e120">Financial Analyst and Advisor</p>
<p class="tx1" id="d7e122">“With the leading edge of nearly 80 million baby boomers set to hit the entry-age for reverse mortgages in the next year and reverse mortgage lending up 73 percent in 2006, this book is a must.”</p>
<p class="tx1" id="d7e125">— <b>Robert Crandall, C.P.A.,</b> Member,</p>
<p class="tx1" id="d7e130">American Institute of Certified Public Accountants</p>
<p class="tx1" id="d7e132">“The one-of-a-kind graphics and clear writing style in the Kraemers' book unravel the mystery of how reverse mortgages transform home equity into useable retirement cash.”</p>
<p class="tx1" id="d7e134">— <b>John N. Yates, CLU, CFP, ChFC and MSFS,</b></p>
<p class="tx1" id="d7e138">Financial Planner</p>
<p class="tx1" id="d7e140">“<i>The Complete Guide to Reverse Mortgages</i> eliminates common misconceptions and distills a complex subject into an accessible resource for borrowers, their families, and the professionals who advise them.”</p>
<p class="tx1" id="d7e145">— <b>Robert Wrubel,</b></p>
<p class="tx1" id="d7e149">Senior Investment Consultant</p>
<p class="tx1" id="d7e151">“The Kraemers have taken a complex subject and made it very understandable.”</p>
<p class="tx1" id="d7e153">— <b>Diana Capoot,</b></p>
<p class="tx1" id="d7e157">Financial Consultant</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Krae_9781440501029_epub_part3.vue?1c2a4534